import { render } from "./NFRPayouts.vue?vue&type=template&id=6434a1fb&scoped=true"
import script from "./NFRPayouts.vue?vue&type=script&lang=js"
export * from "./NFRPayouts.vue?vue&type=script&lang=js"

import "./NFRPayouts.vue?vue&type=style&index=0&id=6434a1fb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6434a1fb"]])

export default __exports__